import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_CUSTOMERS_OVERVIEW_API,
	GET_GUESTS_OVERVIEW_API,
	GET_TEMPORARIES_OVERVIEW_API,
	GET_CUSTOMERS_OVERVIEW_OPTIONS_API,
	GET_GUEST_OVERVIEW_OPTIONS_API,
	POST_TEMPORARIES_OVERVIEW_OPTIONS_API,
	POST_GUESTS_EXCEL_API,
} from "@apis/apiPath";
import { useSnackbar } from "notistack";

const nonMemberSearchBarOptionMap = {
	customer: GET_CUSTOMERS_OVERVIEW_OPTIONS_API,
	prospect: GET_GUEST_OVERVIEW_OPTIONS_API,
	temporary: POST_TEMPORARIES_OVERVIEW_OPTIONS_API,
};

const nonMemberOverviewDataMap = {
	customer: GET_CUSTOMERS_OVERVIEW_API,
	prospect: GET_GUESTS_OVERVIEW_API,
	temporary: GET_TEMPORARIES_OVERVIEW_API,
};

const useNonMemberApi = () => {
	const Ajax = useAjax();
	const { enqueueSnackbar } = useSnackbar();

	// 初始頁面Option
	const getInitOptionsApi = useCallback(
		async type => {
			const initOptions = await Ajax.get(nonMemberSearchBarOptionMap[type]);
			if (initOptions) return initOptions;
			else {
				enqueueSnackbar("資料讀取有誤，請重新整理", { variant: "error" });
			}
		},
		// eslint-disable-next-line
		[]
	);

	const getInitCustomerOptionsApi = useCallback(
		async () => {
			const initOptions = await Ajax.get(GET_CUSTOMERS_OVERVIEW_OPTIONS_API);
			if (initOptions) return initOptions;
		},
		// eslint-disable-next-line
		[]
	);

	const getInitProspectOptionsApi = useCallback(
		async () => {
			const initOptions = await Ajax.get(GET_GUEST_OVERVIEW_OPTIONS_API);
			if (initOptions) return initOptions;
		},
		// eslint-disable-next-line
		[]
	);

	const getInitTemporaryOptionsApi = useCallback(
		async () => {
			const initOptions = await Ajax.get(POST_TEMPORARIES_OVERVIEW_OPTIONS_API);
			if (initOptions) return initOptions;
		},
		// eslint-disable-next-line
		[]
	);

	// 顧客 / 名單 / 暫存  總覽資料
	const postOverviewApi = useCallback(
		async ({ type, params = {} }) => {
			const overviewData = await Ajax.post(nonMemberOverviewDataMap[type], params);
			if (overviewData) return overviewData;
			else {
				enqueueSnackbar("資料讀取有誤，請重新整理", { variant: "error" });
			}
		},
		// eslint-disable-next-line
		[]
	);

	// 顧客總覽資料
	const postOverviewCustomerApi = useCallback(
		async params => {
			const overviewData = await Ajax.post(GET_CUSTOMERS_OVERVIEW_API, params);
			if (overviewData) return overviewData;
			else {
				enqueueSnackbar("資料讀取有誤，請重新整理", { variant: "error" });
			}
		},
		// eslint-disable-next-line
		[]
	);

	// 名單總覽資料
	const postOverviewProspectApi = useCallback(
		async params => {
			const overviewData = await Ajax.post(GET_GUESTS_OVERVIEW_API, params);
			if (overviewData) return overviewData;
			else {
				enqueueSnackbar("資料讀取有誤，請重新整理", { variant: "error" });
			}
		},
		// eslint-disable-next-line
		[]
	);

	// 暫存總覽資料
	const postOverviewTemporaryApi = useCallback(
		async params => {
			const overviewData = await Ajax.post(GET_TEMPORARIES_OVERVIEW_API, params);
			if (overviewData) return overviewData;
			else {
				enqueueSnackbar("資料讀取有誤，請重新整理", { variant: "error" });
			}
		},
		// eslint-disable-next-line
		[]
	);

	// 批次匯入名單 Excel
	const postProspectExcelApi = useCallback(
		async (formData) => {
			const resp = await Ajax.post(POST_GUESTS_EXCEL_API, formData, {
				headerOption: {
					contentType: false,
					processData: false,
				},
			});
			return resp;
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getInitOptionsApi,
		getInitCustomerOptionsApi,
		getInitProspectOptionsApi,
		getInitTemporaryOptionsApi,
		postOverviewApi,
		postOverviewCustomerApi,
		postOverviewProspectApi,
		postOverviewTemporaryApi,
		postProspectExcelApi,
	};
};

export default useNonMemberApi;
